export const unMask = (value: string) => {
  if (!value) return value;
  return value.replace(/\D/g, '');
};
